import Loading from "../../../components/loading";
import { ChartTypeEnum } from "../../../models/chart";
import AdminManagePartisanChartForm from "./components/admin-manage-partisan-chart-form/admin-manage-partisan-chart-form";
import AdminManagePartisanChartHeader from "./components/admin-manage-partisan-chart-header";
import useAdminManagePartisanChart from "./hooks/use-admin-manage-partisan-chart";

const AdminManagePartisanChart = () => {
  const state = useAdminManagePartisanChart(ChartTypeEnum.PARTISAN_PRIMARY);

  return (
    <div className="min-h-screen">
      <AdminManagePartisanChartHeader />
      {state.loading ? (
        <Loading />
      ) : (
        <AdminManagePartisanChartForm state={state} />
      )}
    </div>
  );
};

export default AdminManagePartisanChart;
